module.exports = __webpack_public_path__ + "img/layout-wtf.2a951252.svg";